// src/routers/NewFinanceRouter.js
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import useAuthRole from '../Hooks/useAuthRole'; // ✅ use the role hook

const NewFinanceRouter = ({ children, ...rest }) => {
  const { user, isLoading, isNewFinancePlus } = useAuthRole();
  // allow: new_finance OR moderator OR admin (as per your hook)

  if (isLoading) {
    return (
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  }

  const isSignedIn = !!user?.email;
  const canAccess = isSignedIn && isNewFinancePlus;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        canAccess ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export default NewFinanceRouter;
